import { gateEntity } from "../../domain/entities/gate";
import { createGateEntity } from "../../domain/entities/create_gate";
import http from "../../../../plugins/http-common"
import i18n from "../../../../i18n";

export const HttpGateRepository = {
  model: gateEntity,
  model_create: createGateEntity,

  async index() {
    const res = await http.get('gates');

    const arr = [];
    res.data.data.forEach( x => {
        x = x.attributes;
        x.actions = [{
            name: i18n.t('gates.edit'),
            icon: {
                color: 'accent',
                icon: 'edit'
            },
            link: '',
            permission: "gate.update"
        },
        {
            name: i18n.t('gates.delete'),
            icon: {
                color: 'accent',
                icon: 'delete'
            },
            method: 'askDelete',
            permission: "gate.delete"
        }]

        x.actions[0].link = 'gates/edit/' + x.id;
        x['parameters'] = x;

        arr.push(x);
    })
    return arr;
  },

  async save(gate) {
    const res = await http.post('gates', gate);

    return res;
  },

  async show(gate_id){
    const res = await http.get('gates/' + gate_id);

    return res.data.data.attributes;
  },
  
//   async delete(gate_id){

//   },

  async update(gate, gateData){
    const res = await http.put('gates/' + gate, gateData);
    
    return res;
  },

  async free_gates() {
    const res = await http.get('free_gates');

    return res;
  }
};